<app-lastplayers
  [lastPlayers]="(lastPlayers$ | async)!"
  [loading]="!!(loading$ | async)"
  [theme]="theme"
></app-lastplayers>
